<template>
  <ContentInfoLinks :links="links" />
</template>

<script>
import ContentInfoLinks from 'chimera/all/themes/blueflow/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      links: [
        {
          title: 'Algemeen',
          to: '/informatie-over-rijscholen/',
        },
        {
          title: 'Rijbewijs A',
          to: '/informatie-over-rijscholen/rijbewijs-a',
        },
        {
          title: 'Rijbewijs B',
          to: '/informatie-over-rijscholen/rijbewijs-b',
        },
        {
          title: 'Rijbewijs BE',
          to: '/informatie-over-rijscholen/rijbewijs-be',
        },
        {
          title: 'Rijbewijs C',
          to: '/informatie-over-rijscholen/rijbewijs-c',
        },
        {
          title: 'Rijbewijs CE',
          to: '/informatie-over-rijscholen/rijbewijs-ce',
        },
        {
          title: 'Rijbewijs D',
          to: '/informatie-over-rijscholen/rijbewijs-d',
        },
        {
          title: 'Rijbewijs DE',
          to: '/informatie-over-rijscholen/rijbewijs-de',
        },
        {
          title: 'Rijbewijs CBR',
          to: '/informatie-over-rijscholen/cbr',
        },
        {
          title: '2toDrive',
          to: '/informatie-over-rijscholen/2todrive',
        },
        {
          title: 'Rijopleiding in stappen',
          to: '/informatie-over-rijscholen/rijopleiding-in-stappen',
        },
        {
          title: 'Theorie examen',
          to: '/informatie-over-rijscholen/theorie-examen',
        },
        {
          title: 'Theorie examen oefenen',
          to: '/informatie-over-rijscholen/theorie-examen-oefenen',
        },
        {
          title: 'Praktijkexamen',
          to: '/informatie-over-rijscholen/praktijkexamen',
        },
        {
          title: 'Tussentijdse toets',
          to: '/informatie-over-rijscholen/tussentijdse-toets',
        },
      ],
    }
  },
}
</script>
